import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersBelongingEmployeesSkillEvaluationTermsIndexRequestType,
  ApiManagersBelongingEmployeesSkillEvaluationTermsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersBelongingEmployeesSkillEvaluationTermsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersBelongingEmployeesSkillEvaluationTermsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBelongingEmployeesSkillEvaluationTermsIndexResponseType>(
      "/api/managers/skill_evaluation_terms",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersBelongingEmployeesSkillEvaluationTermsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBelongingEmployeesSkillEvaluationTermsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersBelongingEmployeesSkillEvaluationTermsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBelongingEmployeesSkillEvaluationTermsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
